<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="form-group">
                    <label>Product</label>
                    <div class="text-danger" v-if="productPricingDelivery.productId.hasError">
                        {{productPricingDelivery.productId.errorMessage}}
                    </div>
                    <input class="form-control" type="text" v-model="productPricingDelivery.product" disabled v-if="isUpdate"/>
                    <bootstrap-select v-if="!isUpdate" :selectOptions="products" :selectedOption="productPricingDelivery.productId.value" :elementId="'productSelect'"
                                      :returnSelectedOptionText="true"
                                      @changeSelect="onProductSelect"></bootstrap-select>
                </div>
                <div class="form-group">
                    <label>Zones Pricing</label>
                    <div class="text-danger">
                        {{productPricingDelivery.zoneErrorMessage}}
                    </div>
                    <zone-product-pricing-add-update-table
                            :zones="zones"
                            :numberOfDecimalPlaces="4"
                            @zoneSelected="onZoneSelected"></zone-product-pricing-add-update-table>
                </div>
                <div class="form-group">
                    <label>Effective Date</label>
                    <div class="text-danger" v-if="productPricingDelivery.effectiveDate.hasError">
                        {{productPricingDelivery.effectiveDate.errorMessage}}
                    </div>
                    <date-picker :format="'DD/MM/YYYY'" :elementId="'effectiveDateSelect'" :date="productPricingDelivery.effectiveDate.value"
                                 :initialiseDate="initialiseDate"
                                 @dateChange="onEffectiveDateSelect"></date-picker>
                </div>
                <button class="btn btn-primary mr-2" :disabled="loading" @click="saveDeliveryPricing">Save</button>
                <button class="btn btn-secondary" :disabled="loading" @click.prevent="onBackClick">Back</button>
            </div>
        </div>
    </div>

    <error-modal :modalHeading="errorModal.modalHeading"
                 :elementId="errorModal.elementId"
                 :modalMessage="errorModal.modalMessage"
                 :showModal="errorModal.showModal"
                 @okClicked="errorModalOkClicked"></error-modal>
    <success-modal
            :modalHeading="successModal.modalHeading"
            :elementId="successModal.elementId"
            :modalMessage="successModal.modalMessage"
            :showModal="successModal.showModal"
            @okClicked="successModalOkClicked">
    </success-modal>
</div>
